'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-tree-edit', {
      url: '/document-tree/edit/:id',
      template: '<document-tree-edit></document-tree-edit>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/document/tree-edit/document-tree-edit.routes.js